module.exports = __webpack_public_path__ + "img/opened.da337aff.webp";